import { FC, useMemo } from 'react';
import Select from '../select';
import { FormProps } from '../helpers';
import { DATADOG_SITE_OPTS } from '@/lib/helpers';
import { Stack } from '@mui/material';
import Text from '@/components/text';
import Chip from '@/components/chip';

interface Props extends FormProps {
  value: string;
  onChange: (value: string) => void;
}

const DatadogSiteSelect: FC<Props> = ({ value, onChange, ...rest }) => {
  const siteOpts = useMemo(() => {
    return DATADOG_SITE_OPTS.map(({ label, value: siteValue, meta }) => ({
      label: (
        <Stack direction="row" alignItems="center" gap={1}>
          <Text>{label}</Text>
          <Chip size="small" label={siteValue} />
        </Stack>
      ),
      value: siteValue,
      meta,
    }));
  }, []);

  const props = {
    ...rest,
    value,
    onChange,
    options: siteOpts,
    label: 'Datadog Site',
  };

  return <Select {...props} />;
};

export default DatadogSiteSelect;
